module.exports = __webpack_public_path__ + "img/idcard-zm.794e52f6.png";